import {
    AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
    Paper, Badge, Drawer, Divider, Switch, FormControlLabel
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';

const Foodandbevaragenavbar = () => {
    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [cartItems, setCartItems] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOnline, setIsOnline] = useState(false);
    const [refresh, setRefresh] = useState(0);

    // 🔥 Detect mobile screen
    const isMobile = useMediaQuery('(max-width:600px)');

    // ✅ Create a ref for the dropdown container
    const dropdownRef = useRef(null);
    const accountButtonRef = useRef(null);

    // ✅ Get saved online/offline status
    useEffect(() => {
        const savedStatus = localStorage.getItem("isOnline");
        if (savedStatus !== null) {
            setIsOnline(savedStatus === "true");
        }
    }, []);

    // ✅ Listen for cart update events
    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        // Listen for cart update events
        window.addEventListener('cartUpdated', handleCartUpdate);

        // Cleanup
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    // ✅ Click outside listener
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close dropdown if clicked outside of both dropdown and account button
            if (
                showContainer &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                accountButtonRef.current &&
                !accountButtonRef.current.contains(event.target)
            ) {
                setShowContainer(false);
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showContainer]);

    // ✅ Logout functionality
    const handleLogout = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            await axios.post(
                "https://backend.maamaas.com/food/api/auth/logout",
                {},
                { headers: { Authorization: `Bearer ${authToken}` } }
            );
        } catch (error) {
            console.error("❌ Logout API failed:", error);
        } finally {
            localStorage.removeItem("authToken");
            localStorage.removeItem("vendorId");
            setShowContainer(false);
            setDrawerOpen(false);
            navigate("/");
        }
    };

    // ✅ Fetch all cart items (no orderType filter)
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/count/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            let items = [];
            let count = 0;

            if (Array.isArray(response.data.cartItems)) {
                items = response.data.cartItems;
                count = items.length;
            } else if (typeof response.data.cartItemsCount === "number") {
                count = response.data.cartItemsCount;
            } else if (typeof response.data === "number") {
                count = response.data;
            }

            setCartItems(items);
            setCartCount(count);
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    // ✅ Fetch restaurant status
    const fetchVendorStatus = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && typeof response.data.online === "boolean") {
                setIsOnline(response.data.online);
            }
        } catch (error) {
            console.error("Error fetching vendor status:", error);
        }
    };

    // ✅ Toggle restaurant open/close
    const handleToggleStatus = async (event) => {
        const newStatus = event.target.checked;
        setIsOnline(newStatus);

        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) {
            alert("Vendor ID missing!");
            return;
        }

        localStorage.setItem("isOnline", newStatus);

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { online: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("Status Update Response:", response.data);



        } catch (error) {
            console.error("Error updating vendor status:", error);

            // ❌ Show backend error message if available
            if (error.response) {
                alert(
                    `Error: Failed to update status!\n\n` +
                    JSON.stringify(error.response.data, null, 2)
                );
            } else {
                alert("Network or server error: " + error.message);
            }
        }
    };

    // ✅ FIXED: Add refresh dependency to refetch cart data when refresh changes
    useEffect(() => {
        fetchCartData();
        fetchVendorStatus();
    }, [refresh]); // ← This is the key fix

    const toggleDrawer = (open) => () => setDrawerOpen(open);

    // ✅ Handle account button click
    const handleAccountClick = () => {
        setShowContainer(!showContainer);
    };

    // ✅ Handle menu item click (close dropdown when menu item is clicked)
    const handleMenuItemClick = (action) => {
        setShowContainer(false);
        if (action === "subscription") {
            navigate("/landingpagesubscription");
        } else if (action === "logout") {
            handleLogout();
        }
    };

    const DrawerContent = (
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
            <Divider />
        </Box>
    );

    return (
        <>
            <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                    {/* Left Side - Logo */}
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", color: "#fff", fontSize: "26px", cursor: "pointer" }}
                        onClick={() => navigate("/fooddashboard")}
                    >
                        MAAMAA'S
                    </Typography>

                    {/* Right Side */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>

                        {/* 🔥 Hide switch on mobile */}
                        {!isMobile && (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isOnline}
                                        onChange={handleToggleStatus}
                                        color="primary"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#00d807ff', // Green when checked (Open)
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#24e22aff', // Green track when checked
                                            },
                                            '& .MuiSwitch-switchBase': {
                                                color: '#4e4d4b', // Red when unchecked (Closed)
                                            },
                                            '& .MuiSwitch-track': {
                                                backgroundColor: '#727170ff', // Red track when unchecked
                                            },
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        sx={{
                                            color: isOnline ? "#03da0aff" : "#4e4d4b", // Green for Open, Red for Closed
                                            fontSize: "1.3rem",
                                            marginTop: "3px"
                                        }}
                                    >
                                        {isOnline ? "Open" : "Closed"}
                                    </Typography>
                                }
                                sx={{ fontWeight: "bold", marginTop: "3px" }}
                            />
                        )}

                        {/* Cart Button */}
                        {/* <IconButton onClick={() => navigate("/foodcart")} sx={{ color: "white" }}>
                            <Badge
                                badgeContent={cartCount}
                                color="error"
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: '#4e4d4b',
                                        color: 'white',
                                        borderRadius: '4px',
                                        padding: '0 6px',
                                        minWidth: '20px',
                                        height: '20px',
                                    }
                                }}
                            >
                                <ShoppingCartIcon fontSize="large" />
                            </Badge>
                        </IconButton> */}

                        {/* User Profile Button */}
                        <IconButton
                            ref={accountButtonRef}
                            onClick={handleAccountClick}
                            sx={{ color: "white" }}
                        >
                            <AccountCircleIcon fontSize="large" />
                        </IconButton>
                    </Box>
                </Toolbar>

                {/* Account Dropdown */}
                {showContainer && (
                    <Paper
                        ref={dropdownRef}
                        sx={{
                            position: "absolute",
                            top: "60px",
                            right: "10px",
                            width: "120px",
                            backgroundColor: "white",
                            boxShadow: 3,
                            borderRadius: "8px",
                            zIndex: 1000
                        }}
                    >
                        <MenuItem onClick={() => handleMenuItemClick("subscription")}>
                            Subscription
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClick("logout")}>
                            Logout
                        </MenuItem>
                    </Paper>
                )}
            </AppBar>

            {/* Drawer */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                {DrawerContent}
            </Drawer>
        </>
    );
};

export default Foodandbevaragenavbar;